(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rampe-product-extras')) {
    customElements.define('rampe-product-extras', class extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('.rampe-details');
        if (!this.root) return;
        this.observer?.disconnect();
        this.place = () => {
          if (!this.isConnected) return;
          this.observer.disconnect();
          try {
            const price = this.root.querySelector('product-price');
            const buy = this.root.querySelector('.buy-buttons-block');
            const offer = this.root.querySelector('[data-rampe-offer]');
            const intro = this.root.querySelector('[data-rampe-intro]');
            const inventory = this.root.querySelector('product-inventory');
            let priceAnchor = price;
            if (price && inventory && !inventory.contains(price) && !price.contains(inventory)) {
              if (price.nextElementSibling !== inventory) price.after(inventory);
              priceAnchor = inventory;
            }
            if (priceAnchor && intro && priceAnchor.nextElementSibling !== intro) priceAnchor.after(intro);
            let about = this.root.querySelector('[data-rampe-about]');
            if (!about) {
              const headings = ['om produktet', 'bli bedre kjent med produktet', 'bli kjent med produktet', 'se detaljer', 'dette får du', 'litt mer om produktet'];
              const summary = Array.from(this.root.querySelectorAll('summary')).find((item) =>
                !item.closest('.buy-buttons-block, variant-picker, product-recommendations') &&
                headings.includes(item.textContent.trim().replace(/\s+/g, ' ').toLocaleLowerCase('nb'))
              );
              const row = summary?.closest('accordion-custom') || summary?.closest('details');
              const anchor = intro || priceAnchor || offer || buy;
              if (row && anchor && !row.contains(anchor) && !row.contains(buy)) {
                const parents = [];
                let parent = row.parentElement;
                while (parent && parent !== anchor.parentElement && parent !== this.root) {
                  parents.push(parent);
                  parent = parent.parentElement;
                }
                if (parent === anchor.parentElement) {
                  about = document.createElement('div');
                  about.setAttribute('data-rampe-about', '');
                  let shell = about;
                  for (const original of parents.reverse()) {
                    const copy = original.cloneNode(false);
                    copy.removeAttribute('id');
                    copy.removeAttribute('data-shopify-editor-block');
                    copy.removeAttribute('data-shopify-editor-section');
                    shell.append(copy);
                    shell = copy;
                  }
                  shell.append(row);
                  anchor.after(about);
                }
              }
            }
            let anchor = priceAnchor;
            if (intro && price) anchor = intro;
            if (about && anchor && !about.contains(anchor)) {
              if (anchor.nextElementSibling !== about) anchor.after(about);
              anchor = about;
            } else if (about && offer && !about.contains(offer)) {
              if (offer.previousElementSibling !== about) offer.before(about);
              anchor = about;
            }
            if (anchor && offer && anchor !== offer && !offer.contains(anchor) && anchor.nextElementSibling !== offer) {
              anchor.after(offer);
            }
          } finally {
            if (this.isConnected) this.observer.observe(this.root, { childList: true, subtree: true, characterData: true });
          }
        };
        this.observer = new MutationObserver(this.place);
        queueMicrotask(this.place);
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
